import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
// import { Auth } from 'aws-amplify';
import { animateScroll as scroll } from 'react-scroll';
import {
  MobileIcon,
  Nav,
  NavbarContainer,
  NavItem,
  NavLinks,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnLink
} from './NavbarElements';

const Navbar = ({ toggle, signinBoolean = false }) => {
  const [scrollNav, setScrollNav] = useState(false);
  // const [btnDialog, setBtnDialog] = useState('Sign In');

  // useEffect(() => {
  //   Auth.currentAuthenticatedUser()
  //     .then(session => {
  //       setBtnDialog('Sign Out');
  //     })
  //     .catch(err => {
  //       setBtnDialog('Sign In')
  //       console.log(err)
  //     })
  // });


  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo onClick={toggleHome} to='/'>
              Lay Trader, Inc.
            </NavLogo>
            <MobileIcon onClick={toggle}>
              <FaBars />
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLinks
                  to='who'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Who
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='what'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  What
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='why'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  Why
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='How'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  How
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks
                  to='when'
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact='true'
                  offset={-80}
                >
                  When
                </NavLinks>
              </NavItem>
            </NavMenu>
            {/* <NavBtn>
              <NavBtnLink to='/laytrader'>Lay Trader</NavBtnLink>
            </NavBtn> */}
            <NavBtn>
              {
                signinBoolean ?
                  <NavBtnLink to='/signin'>Sign Out</NavBtnLink>
                  : (
                    <NavBtnLink to='/account'>Account</NavBtnLink>
                  )
              }
            </NavBtn>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
